import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const WhatsAppSelector = ({ className = "" }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const whatsappNumbers = [
    {
      id: 1,
      number: '584245099858',
      label: 'WhatsApp Principal',
      displayNumber: '+58 424-5099858'
    },
    {
      id: 2,
      number: '584245780031',
      label: 'WhatsApp Alternativo',
      displayNumber: '+58 424-5780031'
    }
  ];

  const handleWhatsAppClick = (number) => {
    const message = encodeURIComponent('¡Hola! Me interesa conocer más sobre los libros de Librería Lithay.');
    window.open(`https://wa.me/${number}?text=${message}`, '_blank');
    setIsModalOpen(false);
  };

  // Close modal on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setIsModalOpen(false);
      }
    };

    if (isModalOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  return (
    <>
      {/* WhatsApp Button */}
      <button
        onClick={() => setIsModalOpen(true)}
        className={`bg-white/20 hover:bg-[#c37046] text-white hover:text-white transition-all duration-200 rounded-full p-2 backdrop-blur-sm flex items-center justify-center group ${className}`}
        title="Contactar por WhatsApp"
      >
        <Icon name="MessageCircle" size={18} />
      </button>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 bg-white flex flex-col">
          {/* Modal Content */}
          <div className="w-full h-full flex flex-col transform transition-all duration-300 animate-in fade-in zoom-in">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="bg-green-500 rounded-full p-2">
                  <Icon name="MessageCircle" size={20} className="text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900">
                  Contactar por WhatsApp
                </h3>
              </div>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
              >
                <Icon name="X" size={20} />
              </button>
            </div>

            {/* Body */}
            <div className="flex-1 flex flex-col justify-center p-8 md:p-12">
              <div className="max-w-2xl mx-auto w-full">
                <p className="text-gray-600 text-lg mb-8 text-center">
                  Selecciona el número de WhatsApp para contactarnos:
                </p>
                
                <div className="space-y-6">
                  {whatsappNumbers.map((contact) => (
                    <button
                      key={contact.id}
                      onClick={() => handleWhatsAppClick(contact.number)}
                      className="w-full p-6 md:p-8 text-left hover:bg-green-50 active:bg-green-100 transition-colors duration-200 rounded-2xl border border-gray-200 hover:border-green-300 flex items-center gap-6 group shadow-lg hover:shadow-xl"
                    >
                      <div className="bg-green-500 group-hover:bg-green-600 rounded-full p-4 md:p-6 transition-colors duration-200">
                        <Icon name="MessageCircle" size={32} className="text-white" />
                      </div>
                      <div className="flex-1">
                        <div className="text-xl md:text-2xl font-medium text-gray-900 group-hover:text-green-700 transition-colors duration-200 mb-2">
                          {contact.label}
                        </div>
                        <div className="text-lg md:text-xl text-gray-500 group-hover:text-green-600 transition-colors duration-200">
                          {contact.displayNumber}
                        </div>
                      </div>
                      <Icon name="ExternalLink" size={24} className="text-gray-400 group-hover:text-green-500 transition-colors duration-200" />
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 pb-8">
              <div className="text-sm text-gray-500 text-center">
                Se abrirá WhatsApp con un mensaje predeterminado
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsAppSelector;
